import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';
import EventLabel from '../../components/EventLabel/EventLabel';
import { MeetingStatus } from './types';
import { formatDateRange } from '../../utils/date.utils';

interface IBookingDialogProps {
  meeting: any;
  onClose: () => void;
  onCancelMeeting: (meetingId: number) => void;
  onAcceptMeeting: (meetingId: number) => void;
  style: any;
}

export default function MeetingDetails({ meeting, onClose, onCancelMeeting, onAcceptMeeting, style }: IBookingDialogProps) {
  const { meetingId, isRequested, start, end, inviteMessage, location, status } = meeting;

  const booker = meeting.participants?.find(p => p.role === 'booker');

  return (
    <Transition appear show as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto" style={{ fontFamily: style?.['font-family'] }}>
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white  text-left align-middle shadow-xl transition-all">
                <div className="p-6 flex flex-col gap-y-4">
                  <span className="flex items-center text-lg gap-x-2  w-full relative">
                    <i className="ri-calendar-check-line"></i>
                    <span>
                      {meeting.status === MeetingStatus.PENDING ? (
                        <EventLabel name="MeetingRequest" groupName="CMS.MatchMaking" />
                      ) : (
                        <EventLabel name="MeetingDetails" groupName="CMS.MatchMaking" />
                      )}
                    </span>

                    <i className="ri-close-line absolute right-1 -top-1 cursor-pointer" onClick={onClose} />
                  </span>
                  <div className="divide-y divide-divider border-divider  border rounded-md w-full">
                    <div className="flex gap-x-3  p-2 pr-8 pl-3">
                      <span>
                        <i className="ri-user-shared-line" />
                      </span>
                      <span>
                        {booker?.order?.person?.firstName} {booker?.order?.person?.lastName}
                      </span>
                    </div>
                    <div className="flex gap-x-3  p-2  pr-8 pl-3">
                      <span>
                        <i className="ri-calendar-line"></i>
                      </span>
                      <span>{`${new Date(start).toLocaleDateString('sv-SE')}`}</span>
                    </div>
                    <div className="flex gap-x-3  p-2 pr-8 pl-3">
                      <span>
                        <i className="ri-time-line"></i>
                      </span>
                      <span>
                        {` ${new Date(start).toLocaleTimeString('sv-SE')?.substring(0, 5)} - ${new Date(end).toLocaleTimeString('sv-SE')?.substring(0, 5)}`}
                      </span>
                    </div>
                    <div className="flex gap-x-3  p-2 pr-8 pl-3">
                      <span>
                        <i className="ri-map-pin-line"></i>
                      </span>
                      <span>{location}</span>
                    </div>
                  </div>

                  <div className="p-4 bg-neutral-50 border-l-4 border-divider border rounded-sm border-l-neutral-300 italic text-sm flex flex-col gap-y-1">
                    {inviteMessage}
                    <span className="font-bold">
                      - {booker?.order?.person?.firstName} {booker?.order?.person?.lastName}
                    </span>
                  </div>
                  {status === MeetingStatus.TIME_OUT ? (
                    <div>
                      <i className="ri-time-line mr-1"></i>
                      <EventLabel name="MeetingTimout" groupName="CMS.MatchMaking" />
                    </div>
                  ) : (
                    <div className="flex gap-x-2">
                      {meeting.status === MeetingStatus.PENDING && isRequested && (
                        <button className="bg-green-600 text-white rounded-md text-sm focus:outline-none" onClick={() => onAcceptMeeting(meetingId)}>
                          <EventLabel name="AcceptMeeting" groupName="CMS.MatchMaking" />
                        </button>
                      )}
                      <button className="bg-danger text-white rounded-md text-sm focus:outline-none" onClick={() => onCancelMeeting(meetingId)}>
                        <EventLabel name="CancelMeeting" groupName="CMS.MatchMaking" />
                      </button>
                    </div>
                  )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
